import React, { useState } from "react";

import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { errorAwareApiFetch } from "../../../../../../apiBindings";
import { roundNumber } from "../../../../../../utils/NumberHelpers";
import { storageSession } from "../../../../../../utils/StorageHandler";
import FormError from "../../../../../shared/forms/FormError";
import NewInput from "../../../../../shared/forms/NewInput";
import Button from "../../../../../shared/NewForms/Button";
import useStore from "./store";

const Container = styled.div`
    margin-top: 30px;
    margin-bottom: 30px;
`;

const Form = styled.form`
    display: flex;
    gap: 20px;
    align-items: flex-start;
`;

const EnteredVoucher = styled.div`
    display: flex;
    align-items: center;
`;

const Question = styled.div`
    font-weight: 500;
`;

const submitButtonStyles = css`
    margin-top: 5px;
`;

const deleteButtonStyles = css`
    font-weight: normal;
    text-decoration: underline !important;
`;

const Voucher = () => {
    const [loading, setLoading] = useState(false);
    const [voucher, setVoucher] = useState("");
    const [validationError, setValidationError] = useState(false);
    const [error, setError] = useState("");
    const { storeVoucher, name, value, setData, reset } = useStore((state) => ({
        storeVoucher: state.voucher,
        name: state.name,
        value: state.value,
        setData: state.setData,
        reset: state.reset,
    }));

    console.log(storageSession.get("hel:voucher:code", ""));

    /**
     * When the order comment changes.
     *
     * @param {*} event
     */
    const onChangeVoucher = (event) => {
        setError("");
        setVoucher(event.target.value);
    };

    const onSubmit = async (event) => {
        event.preventDefault();
        setLoading(true);
        setError("");
        await errorAwareApiFetch(`/heatingoil/checkout/check-voucher`, {
            method: "POST",
            body: JSON.stringify({ voucher }),
        })
            .then((response) => {
                console.log(response.data.name, response.data.value);
                setData(voucher, response.data.name, response.data.value);
            })
            .catch((error) => {
                if (error.response.status === 422) {
                    setError(error.data.message);
                }
            })
            .finally(() => setLoading(false));
    };

    const removeVoucher = () => {
        reset();
        setVoucher("");
    };

    return (
        <Container>
            <Question>Hast Du einen Gutschein?</Question>
            {storeVoucher && (
                <EnteredVoucher>
                    <div>
                        {name} {roundNumber(value)}&nbsp;€ (Code: {storeVoucher}
                        )
                    </div>
                    <Button
                        color="blue"
                        text
                        extraSmall
                        onClick={removeVoucher}
                        css={deleteButtonStyles}
                    >
                        Entfernen
                    </Button>
                </EnteredVoucher>
            )}
            {!storeVoucher && (
                <Form onSubmit={onSubmit}>
                    <div>
                        <NewInput
                            placeholder="Gutschein"
                            value={voucher}
                            onChange={onChangeVoucher}
                            validation="voucher"
                            onError={() => setValidationError(true)}
                            onErrorSolved={() => setValidationError(false)}
                        />
                    </div>
                    <div>
                        <Button
                            color="redOutline"
                            type="submit"
                            disabled={
                                loading || validationError || voucher === ""
                            }
                            css={submitButtonStyles}
                        >
                            Einlösen
                        </Button>
                    </div>
                </Form>
            )}
            {error && <FormError message={error} />}
        </Container>
    );
};

export default Voucher;
